import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-teaser/jb-ref-teaser.ts
import "@bjb/bjb-web-components/dist/components/jb-picture/jb-picture";
import "@bjb/bjb-web-components/dist/components/jb-teaser-header/jb-teaser-header";
import "@bjb/bjb-web-components/dist/components/jb-thumbnail/jb-thumbnail";
import { jbLinkClickedEventToJbTrackingEvent, Linkable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/jb-ref-teaser/jb-ref-teaser.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_teaser_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h3 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h3 {
  font-size: var(--theme-typo-h3-mobile-fontsize, 1.375rem);
  font-weight: var(--theme-typo-h3-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-h3-mobile-lineheight, 1.75rem);
}

@media (min-width: 1281px) {
  h3 {
    font-size: var(--theme-typo-h3-desktop-fontsize, 1.625rem);
    line-height: var(--theme-typo-h3-desktop-lineheight, 2.25rem);
  }
}
.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  display: block;
  --teaser-header-h3-margin-bottom: 20px;
  --teaser-header-h3-margin-top: 20px;
}

article {
  margin-bottom: var(--article-card-bottom, 0);
  position: relative;
}
article.horizontal {
  display: flex;
  gap: 10px;
}
@media (min-width: 600px) {
  article.horizontal {
    gap: 16px;
  }
}
article.no-image {
  --teaser-header-h3-margin-top: 0;
  border: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  transition: border 0.7s ease-in-out 0s;
}
article.no-image:hover {
  border-color: #141e55;
}

.wrapper {
  position: relative;
}

.image-link {
  flex-basis: 25%;
  flex-shrink: 0;
}
@media (min-width: 960px) {
  .image-link {
    flex-basis: 33%;
  }
}

.horizontal .text-link {
  padding-bottom: 0;
}
.no-image .text-link {
  padding: 24px 24px 0;
}

.horizontal jb-ref-teaser-meta {
  position: static;
}
.no-image jb-ref-teaser-meta {
  display: flex;
  padding: 0 24px 24px;
}

a {
  display: block;
  text-decoration: none;
}
a figure {
  overflow: hidden;
}

h3 {
  padding-bottom: 16px;
}

@media print {
  :host {
    break-inside: avoid;
  }
}`;

// src/components/jb-ref-teaser/jb-ref-teaser.ts
var JbRefTeaser = class extends Linkable(LitElement) {
  constructor() {
    super(...arguments);
    this.direction = "vertical";
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "teaser"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    const classes = {
      horizontal: this.direction === "horizontal",
      "no-image": !this.teaserHeader.picture && !this.teaserHeader.thumbnail
    };
    return html`
      <article class="${classMap(classes)}">
        ${this.direction === "horizontal" ? html`
              <a
                class="image-link"
                data-linkable
                @jb-link:clicked=${this._tracking}
              >
                ${this.teaserHeader.picture ? html`
                      <jb-picture
                        .alt=${this.teaserHeader.picture.alt}
                        .fit=${"cover"}
                        .imgData=${this.teaserHeader.picture.imgData}
                        .lazy=${this.teaserHeader.picture.lazy}
                      ></jb-picture>
                    ` : nothing}
                ${this.teaserHeader.thumbnail ? html`
                      <jb-thumbnail
                        .backgroundPicture="${this.teaserHeader.thumbnail.backgroundPicture}"
                        .videoSrc="${this.teaserHeader.thumbnail.videoSrc}"
                        .aspect="${this.teaserHeader.thumbnail.aspect}"
                        .type="${this.teaserHeader.thumbnail.type}"
                      ></jb-thumbnail>
                    ` : nothing}
              </a>
            ` : nothing}
        <div class="wrapper">
          <a
            class="text-link"
            data-linkable
            @jb-link:clicked=${this._tracking}
          >
            ${this.direction !== "horizontal" ? html`
                  <jb-teaser-header
                    .headline=${this.teaserHeader.headline}
                    .picture=${this.teaserHeader.picture}
                    .teaser=${this.teaserHeader.teaser}
                    .thumbnail=${this.teaserHeader.thumbnail}
                    ?gallery=${this.gallery}
                  ></jb-teaser-header>
                ` : html` <h3>${this.teaserHeader.headline}</h3> `}
          </a>
          ${this.teaserMeta ? html` <jb-ref-teaser-meta
                .infos=${this.teaserMeta.infos}
                .tags=${this.teaserMeta.tags}
              ></jb-ref-teaser-meta>` : nothing}
        </div>
      </article>
    `;
  }
};
JbRefTeaser.styles = unsafeCSS(jb_ref_teaser_default);
__decorateClass([
  property()
], JbRefTeaser.prototype, "direction", 2);
__decorateClass([
  property({ type: Boolean })
], JbRefTeaser.prototype, "gallery", 2);
__decorateClass([
  property({ type: Object })
], JbRefTeaser.prototype, "teaserHeader", 2);
__decorateClass([
  property({ type: Object })
], JbRefTeaser.prototype, "teaserMeta", 2);
JbRefTeaser = __decorateClass([
  customElement("jb-ref-teaser")
], JbRefTeaser);

export {
  JbRefTeaser
};
